import React, { useEffect, useState } from 'react';
import { Typography } from "@material-tailwind/react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import pkg from '../../../package.json'
import './sidebar.css';
import { NavLink, useNavigate } from 'react-router-dom';
import routes from '../../routes';
import { setToggleSidebar, setSearch, setCurrentPage, setCheckedValues, setTotalPage, setEncodingString, setPerPage, handleReset } from '../../reducers/contextSlice';
import { useSelector, useDispatch } from 'react-redux';

export const Sidebar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(`/${window.location.hash.split('/')[1]}`);
  const [currentPath, setCurrentPath] = useState('')
  const { toggleSidebar } = useSelector(state => state.context);
  const currentRoutes = routes.sidebarRoutes;

  const dispatch = useDispatch();

  useEffect(() => {
  }, [currentPath])

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  return (
    <>
      {/* Mobile overlay */}
      <div 
        className={`bg-neutral-900/50 backdrop-blur-sm fixed inset-0 ${toggleSidebar ? `block z-60` : `hidden`}`} 
        onClick={() => dispatch(setToggleSidebar(!toggleSidebar))}
      />
      
      {/* Sidebar */}
      <aside className={`
        ${toggleSidebar ? "translate-x-0" : "-translate-x-80"} 
        fixed h-full w-64 bg-sidebar-bg border-r border-sidebar-border
        transition-transform duration-300 ease-in-out
        2xl:translate-x-0 z-70
        flex flex-col
      `}>
        {/* Logo Section */}
        <div className="flex items-center justify-between px-5 py-6 border-b border-sidebar-border">
          <div className="flex items-center gap-2.5">
            <img 
              src="../../assets/images/foto-ai-logo.svg" 
              className='h-10' 
              alt="Foto AI Logo" 
            />
            <span className='text-xs font-semibold text-text-tertiary'>
              v{pkg.version}
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav className='flex-1 overflow-y-auto py-4 px-3 space-y-1 sidebar thin-scrollbar'>
          {currentRoutes?.map(({ name, path, icon, items }, i) => (
            <div key={path}>
              {items ? (
                // Accordion Navigation Item
                <div>
                  <button
                    onClick={() => {
                      setCurrentPath(name);
                      dispatch(setSearch(""));
                      dispatch(setCheckedValues([]));
                      dispatch(setEncodingString([]));
                      handleOpen(i + 1);
                      setActiveAccordian(path);
                      dispatch(setCurrentPage(1));
                      dispatch(setPerPage(15));
                      dispatch(setTotalPage(1));
                      navigate(path);
                    }}
                    className={`
                      w-full flex items-center justify-between px-3 py-2.5 rounded-lg
                      text-sm font-medium transition-all duration-150
                      ${items.find(_ele => _ele.path === activeAccordian) || open === i + 1
                        ? 'text-primary-500 bg-sidebar-active-bg'
                        : 'text-text-secondary hover:text-text-primary hover:bg-sidebar-hover'
                      }
                    `}
                  >
                    <div className="flex items-center gap-3">
                      <span className={`
                        flex-shrink-0 
                        ${items.find(_ele => _ele.path === activeAccordian) || open === i + 1
                          ? 'text-primary-500'
                          : 'text-text-tertiary'
                        }
                      `}>
                        {icon}
                      </span>
                      <span className="capitalize">{name}</span>
                    </div>
                    <ChevronRightIcon 
                      className={`
                        h-4 w-4 flex-shrink-0 transition-transform duration-200
                        ${open === i + 1 ? 'rotate-90' : ''}
                      `}
                    />
                  </button>

                  {/* Sub-items */}
                  {open === i + 1 && (
                    <div className="mt-1 ml-9 space-y-0.5">
                      {items?.map(({ name, path }) => (
                        <NavLink
                          key={path}
                          to={path}
                          onClick={() => {
                            setCurrentPath(name);
                            dispatch(setEncodingString([]));
                            dispatch(setSearch(""));
                            dispatch(setCheckedValues([]));
                            dispatch(setToggleSidebar(false));
                            setActiveAccordian(path);
                            dispatch(setCurrentPage(1));
                          }}
                          className={({ isActive }) => `
                            block px-3 py-2 rounded-md text-sm font-normal
                            transition-colors duration-150 capitalize
                            ${isActive
                              ? 'text-primary-500 bg-sidebar-active-bg'
                              : 'text-text-secondary hover:text-text-primary hover:bg-sidebar-hover'
                            }
                          `}
                        >
                          {name}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                // Simple Navigation Item
                <NavLink
                  to={path}
                  onClick={() => {
                    setCurrentPath(name);
                    dispatch(setSearch(""));
                    dispatch(setCheckedValues([]));
                    setOpen(0);
                    dispatch(setToggleSidebar(false));
                    setActiveAccordian(false);
                    dispatch(setCurrentPage(1));
                    dispatch(setEncodingString([]));
                  }}
                  className={({ isActive }) => `
                    flex items-center gap-3 px-3 py-2.5 rounded-lg
                    text-sm font-medium transition-all duration-150 capitalize
                    ${isActive
                      ? 'text-primary-500 bg-sidebar-active-bg'
                      : 'text-text-secondary hover:text-text-primary hover:bg-sidebar-hover'
                    }
                  `}
                >
                  <span className="flex-shrink-0">{icon}</span>
                  <span>{name}</span>
                </NavLink>
              )}
            </div>
          ))}
        </nav>

        {/* Footer - optional help or settings link */}
        <div className="px-3 py-4 border-t border-sidebar-border">
          <div className="px-3 py-2 text-xs text-text-tertiary">
            © 2026 Foto AI Admin
          </div>
        </div>
      </aside>
    </>
  )
}

export default Sidebar